export default "__VITE_ASSET__CrJyu047__"